import { render, staticRenderFns } from "./quesGuide.vue?vue&type=template&id=ede3212a"
import script from "./quesGuide.vue?vue&type=script&lang=js"
export * from "./quesGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports